import React from "react";
import {Redirect, Route, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Cookies from 'js-cookie'
import store from 'utils/store'
class AppRoute extends React.Component {
  shouldContinue({isPrivate, isPublic, auth, path}) {
    let cookie=Cookies.get('stories_session')
    if(!cookie && isPrivate){
      //user is not authenticated
      //save the URL to a cookie for 15 minutes
      var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
      Cookies.set('stories_url', path, {expires: inFifteenMinutes})
      store.dispatch({type:"LOGOUT"})
      return {load:false, path:"/login"}
    }
    if (isPrivate) {
     return {
       load: auth,
       path: "/"
     }
    }
    if (isPublic) {
     return {
       load: !auth,
       path: "/"
     }
    }
    return {
     load: true,
    }
  }
  render() {
    let props = {...this.props}
    let Component = props.component;
    delete props["component"]
    let cont = this.shouldContinue({
      isPrivate: props.isPrivate,
      isPublic: props.isPublic,
      auth: props.authenticated,
      path: props.path
    })
    return (
      <Route {...props} render={(props) => (
        cont.load ? (
          <Component {...props}/>
        ) : (
          <Redirect to={{
            pathname: cont.path,
            state: {from: props.location},
            toast: cont.toast
          }}/>
        )
      )}
      />
    )
  }
}

const mapStateToProps = function (state) {
  return {authenticated: state.user.authenticated, user: state.user.userData};
}
export default withRouter(connect(mapStateToProps)(AppRoute))



// WEBPACK FOOTER //
// ./src/utils/route.js